import { Header } from '@pentabd/ui';
import { useTranslation } from 'react-i18next';

export function CenterWiseResultsHeader() {
  const { t } = useTranslation();

  const headerText = {
    header: t('CENTER_WISE_RESULTS.HEADER.TEXT'),
  };

  return (
    <div className="mt-20">
      <Header headerText={headerText} />
    </div>
  );
}
